import React, { Component } from 'react';
import { connect } from 'react-redux';

import axios from "axios";
import { withRouter } from 'react-router-dom'

import { LoadingIcon } from '../Common/Loading_Icon';
import { DisplayQuestion } from './Survey/Survey.jsx';

import { setUserSession } from "../../Actions/userSessionActions";
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import moment from 'moment';

class Survey extends Component {
    constructor(props) {
        super(props);

        this.createEulaMarkup = this.createEulaMarkup.bind(this);
        this.loadSurvey = this.loadSurvey.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.checkIfJson = this.checkIfJson.bind(this);
        this.renderProgressBar = this.renderProgressBar.bind(this);

        this.state = {
            loading_page: true,
            submiting_question: false,
            errors: [],
            form_details: {},
            survey_form: [],
            page: "", question: {}, responses: [], options: {},
            total_questions: 1
        };
    }

    componentDidMount() {
        document.title = "Survey - FleetXPress"
        var self = this;

        axios.get('/ajax/survey')
        .then((response) => {
            if (response?.data.page === 'role_select') {
                self.props.history.push("/roleselection");
            } else {
                this.state.form_details.question_id = response?.data.question.Id;

                var responses = []; 
    
                jQuery.each(response?.data.responses, function( i, resp) {
                    if(response.Answer != null) {
                        responses.push(response.Answer);
                    } else if(response.Response_Choice_Id != null) {
                        responses.push(response.Response_Choice_Id);
                    } else {
                        responses.push(null);
                    }
                });
    
                this.state.form_details.answer = responses;
    
                self.setState({
                    loading_page: false,
                    page: response?.data.page,
                    question: response?.data.question,
                    responses: response?.data.responses,
                    options: response?.data.options,
                    total_questions: response?.data.total_questions
                })
            }

            if (response?.data.language !== "English") {
                var language_code = 'fr';

                i18n.changeLanguage(language_code)
                moment.locale(language_code);
            }
        })
        .catch(function(error) {
            if(error.response?.data.error == "Survey Completed") {
                self.props.history.push("/" + error.response?.data.redirect);
            }
        })
    }

    createEulaMarkup(html_text) {
        return {__html: html_text}
    }

    loadSurvey(e, props, action, form = []) {
        e.preventDefault();

        var self = this;
        var survey_form = self.state.survey_form;

        this.setState({
            submiting_question: true
        });

        if(action == "previous")
        {
            survey_form = {question_id: props.question.Id}
        }
        else if(action == "next" && form.length != 0)
        {
            survey_form = form;
        }

        axios({
            method: 'post',
            url: '/ajax/survey/' + action,
            data: survey_form,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        })
        .then((response) => {
            if(response?.data.page == 'success') {
                var userSessionObj = self.props.userSession;
                userSessionObj.user.pending_survey = false;
                self.props.dispatch({type: "SET_SESSION_OEM", payload: userSessionObj.user});
            }

            this.state.form_details.question_id = response?.data.question.Id;

            var fetched_responses = []; 

            jQuery.each(response?.data.responses, function( i, resp) {                
                if(resp.Answer != null) {
                    fetched_responses.push(resp.Answer);
                } else if(response.Response_Choice_Id != null) {
                    fetched_responses.push(resp.Response_Choice_Id);
                } else {
                    fetched_responses.push(null);
                }
            });

            this.state.form_details.answer = fetched_responses;

            //handle success
            this.setState({
                page: response?.data.page,
                question: response?.data.question,
                responses: response?.data.responses,
                options: response?.data.options,
                errors: response?.data.errors,
                submiting_question: false
            })

            if(response?.data.errors.length > 0)
            {
                var error_message = "";

                $.each(response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            }
        })
        .catch(function(error) {

            this.setState({
                submiting_question: false
            });

            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    //Whenever an input is changed, will call this function and set the corresponding state variable to the input to be used for logging in
    //Useful for any component with a form in it
    handleChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var survey_form = this.state.survey_form;
        survey_form[name] = value;

        this.setState({
            survey_form: survey_form
        });
    }

    handleResponse(e, props, response) {
        var self = this;
        var survey_form = self.state.survey_form;

        /* handle responses for multipe questions in one page

        var question_exists_flag = false;
        if(survey_form.length > 0) // check form doesn't already have the response
        {
            survey_form.forEach(function (resp, index) {
                if(resp.question_id == response.question_id)
                {
                    question_exists_flag = true;
                    survey_form[index] = response;
                }
            });
        }
        
        if(!question_exists_flag)
        {
            survey_form.push(response);
        }*/

        survey_form = response;

        self.setState({
            survey_form: survey_form
        });

        this.loadSurvey(e, props, "next", survey_form);
    }

    renderProgressBar(total_questions, order) {
        var progress = [];

        for (var count = 1; count <= total_questions; count++)
        {
            progress.push(
                <>
                    <span className={"registration-progress-step" + (count == order ? " active" : "")}></span>
                    {
                        count != total_questions ?
                            <span className="registration-progress-divider"></span>
                        :
                            null
                    }
                </>
            );
        }

        return progress;
    }

    checkIfJson(json) {
        try {
            JSON.parse(json);
        } catch (e) {
            return false;
        }

        return true;
    }
    
    render() {
        if(!this.state.loading_page) {
            return (
                <div className = "validation-container">
                    {
                        this.state.submiting_question ? 
                            <LoadingIcon />
                        :
                            null
                    }
                    <div className="registration-navbar">
                        <img src="images/dvms_logo.png" />
                    </div>
                    <div className="registration-card validation-card">
                        <div className="registration-progress">
                            { this.renderProgressBar(this.state.total_questions, ("question_orders" in this.state.question && this.state.question.question_orders[0] != undefined ? this.state.question.question_orders[0].Question_Order : this.state.total_questions)) }
                        </div>
                        <div className="survey-header">
                            <div className="survey-heading">
                                {
                                    this.checkIfJson(this.state.question.Help_Text) && "header" in (JSON.parse(this.state.question.Help_Text)) ?
                                        (JSON.parse(this.state.question.Help_Text)).header
                                    :
                                        <Trans>Tell us a little bit about your work.</Trans>
                                }
                            </div>
                        </div>
                        <DisplayQuestion history={this.props.history} match={this.props.match} location={this.props.location} page={this.state.page} question={this.state.question} responses={this.state.responses} settings={this.props.settings} errors={this.state.errors} options={this.state.options} loadSurvey={this.loadSurvey} handleResponse={this.handleResponse} />
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingIcon />
            )
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default connect(mapStateToProps,)(Survey);